import { type FC } from "react";

import { ProductDesktop } from "./desktop/ProductDesktop"
import { ProductMobile } from "./mobile/ProductMobile"

import { useMatchMedia } from "../../shared/hooks/useMatchMedia";

export const Product: FC = () => {
	const { isMobile }: any = useMatchMedia();

	const Root = isMobile ? <ProductMobile /> : <ProductDesktop />;

	return Root
};
